module.exports = __webpack_public_path__ + "img/group-7.00974b93.svg";